import React, { useEffect } from 'react';
import _get from 'lodash/get';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { setWidgetTypes, setWidgets } from 'store/homepageWidgets';
import Page from 'components/Page/newComponents';
import Breadcrumbs from 'components/Page/Breadcrumbs';
import PageTitle from 'components/Page/PageTitle';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import CircularProgress from '@material-ui/core/CircularProgress';
import WidgetsTab from './tabs/WidgetsTab';
import LayoutTab from './tabs/LayoutTab';
import { HOME_URL, HOMEPAGE_URL } from 'components/Router/consts';
import { WidgetType, Widget } from 'pages/Homepage/typings';

const tabTypes = {
  WIDGETS: 'widgets',
  LAYOUT: 'layouts',
};

interface Props {
  widgetTypes: Array<WidgetType>;
  widgets: Array<Widget>;
}

function Homepage({ widgetTypes, widgets }: Props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { tab } = useParams<{ tab?: string }>();
  const currentTab = tab || tabTypes.WIDGETS;
  const widgetTypesInRedux: Array<WidgetType> = useSelector(state =>
    _get(state, ['homepageWidgets', 'widgetTypes']),
  );
  const widgetsInRedux: Array<Widget> = useSelector(state =>
    _get(state, ['homepageWidgets', 'widgets']),
  );

  useEffect(() => {
    document.title = 'Homepage';
  }, []);

  useEffect(() => {
    dispatch(setWidgetTypes(widgetTypes));
    dispatch(setWidgets(widgets));
  }, []);

  if (!widgetTypesInRedux || !widgetsInRedux) {
    return <CircularProgress color="secondary" />;
  }

  const handleTabChange = (tabValue: string) => {
    history.push(`${HOME_URL}${HOMEPAGE_URL}/${tabValue}`);
  };

  const tabContentByType = {
    [tabTypes.WIDGETS]: <WidgetsTab />,
    [tabTypes.LAYOUT]: <LayoutTab />,
  };

  return (
    <Page>
      <Breadcrumbs routes={['Home']} />
      <PageTitle
        title="Homepage"
        subtitle="Create and configure widgets for the homepage that end users will see in Sift."
      />
      <Tabs value={currentTab} onChange={(e, value) => handleTabChange(value)}>
        <Tab label="Widgets" value={tabTypes.WIDGETS} />
        <Tab label="Layout" value={tabTypes.LAYOUT} />
      </Tabs>
      {tabContentByType[currentTab]}
    </Page>
  );
}

export default Homepage;
